import { toast } from "react-toastify";

// Reusable Toast Function
export const showToast = (message, type = "error", customOptions = {}) => {
  const options = {
    position: "top-right",
    autoClose: 3000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    ...customOptions,
  };

  switch (type) {
    case "success":
      return toast.success(message, options);
    case "error":
      return toast.error(message, options);
    case "warning":
      return toast.warning(message, options);
    default:
      return toast.info(message, options);
  }
};
